module.exports = __webpack_public_path__ + "static/samsclub-991ce28dba75f8aa06df95a89291f2d9.svg";